<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 90% !important;"
  >
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Novo Investimento' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Investimentos',
                href: '#/investments',
              },
              {
                text: 'Cadastro de Investimentos',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome" id="input-group-1" label-for="input-1">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label="Valor"
                id="input-group-1"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.value"
                  placeholder="Informe o valor do investimento"
                  :state="isOk('value')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('value')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label="Valor Mínimo"
                id="input-group-1"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.valueMinimum"
                  placeholder="Informe o valor o Mínimo"
                  :state="isOk('valueMinimum')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('valueMinimum')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label="Juros Mensal"
                id="input-group-1"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.aliquot"
                  placeholder="Informe o Juros Mensal"
                  :state="isOk('aliquot')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('aliquot')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label="Data de depósito"
                id="input-group-1"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('depositDate')"
                  v-model="state.depositDate"
                  class="mb-2"
                  placeholder="Selecione uma data"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('depositDate')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Status">
                <b-form-select
                  v-model="state.status"
                  :options="viewData.status"
                  :state="isOk('status')"
                  class="mb-3"
                >
                  <option disabled value>Selecione um status</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('status')
                }}</b-form-invalid-feedback>
              </b-form-group>
              <!--
              <b-form-group
                label="Valor Mínimo"
                id="input-group-1"
                label-for="input-1"
              >
                <currency-input
                  v-model="value"
                  :options="{ currency: 'BRL' }"
                />
                <b-form-invalid-feedback>{{
                  getError('valueMinimum')
                }}</b-form-invalid-feedback>
              </b-form-group> -->

              <b-form-group id="input-group-1" label="Período mínimo">
                <b-form-select
                  v-model="state.minPeriod"
                  :options="viewData.periods"
                  :state="isOk('minPeriod')"
                  class="mb-3"
                >
                  <option disabled value>Selecione o período mínimo</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('minPeriod')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Período máximo">
                <b-form-select
                  v-model="state.maxPeriod"
                  :options="viewData.periods"
                  :state="isOk('maxPeriod')"
                  class="mb-3"
                >
                  <option disabled value>Selecione o período máximo</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('maxPeriod')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Resgate antecipado">
                <b-form-select
                  v-model="state.redemption_term"
                  :options="viewData.redemptionPeriods"
                  :state="isOk('redemption_term')"
                  class="mb-3"
                >
                  <option disabled value
                    >Selecione a opção de resgate antecipado</option
                  >
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('redemption_term')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Usina">
                <b-form-select
                  :options="viewData.powerPlants"
                  v-model="state.powerPlantId"
                  :state="isOk('powerPlantId')"
                  class="mb-3"
                >
                  <option disabled value>Selecione a Usina</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('powerPlantId')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'investment-edit',
  data: function() {
    return {
      state: {
        name: '',
        valueMinimum: 0,
        value: '',
        depositDate: null,
        aliquot: 0,
        status: 'ACTIVE',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
        powerPlants: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    this.viewData.status = [
      { value: 'ACTIVE', text: 'Ativo' },
      { value: 'INACTIVE', text: 'Inativo' },
    ];

    this.viewData.periods = [
      { value: 6, text: '06 Meses' },
      { value: 12, text: '12 Meses' },
      { value: 18, text: '18 Meses' },
      { value: 24, text: '24 Meses' },
      { value: 30, text: '30 Meses' },
      { value: 36, text: '36 Meses' },
      { value: 42, text: '42 Meses' },
      { value: 48, text: '48 Meses' },
      { value: 54, text: '54 Meses' },
      { value: 60, text: '60 Meses' },
      { value: 66, text: '66 Meses' },
      { value: 72, text: '72 Meses' },
      { value: 78, text: '78 Meses' },
    ];
    //redemption_term

    this.viewData.redemptionPeriods = [
      {
        value: '60_DAYS',
        text: '60 dias após o recebimento da solicitação pela Veins',
      },
      { value: 'DONT_APPLY', text: 'Não se aplica a essa rodada' },
    ];

    const resultPowerPlant = await API.post('/execute', {
      path: '/power-plants?no_limit=true',
      method: 'get',
    });

    this.viewData.powerPlants = resultPowerPlant.model.list.map(itmPW => {
      return { value: itmPW.id, text: itmPW.name };
    });

    this.viewData.status = [
      { value: 'ACTIVE', text: 'Ativo' },
      { value: 'INACTIVE', text: 'Inativo' },
    ];

    this.viewData.periods = [
      { value: 6, text: '06 Meses' },
      { value: 12, text: '12 Meses' },
      { value: 18, text: '18 Meses' },
      { value: 24, text: '24 Meses' },
      { value: 30, text: '30 Meses' },
      { value: 36, text: '36 Meses' },
      { value: 42, text: '42 Meses' },
      { value: 48, text: '48 Meses' },
      { value: 54, text: '54 Meses' },
      { value: 60, text: '60 Meses' },
      { value: 66, text: '66 Meses' },
      { value: 72, text: '72 Meses' },
      { value: 78, text: '78 Meses' },
    ];
    //redemption_term

    this.viewData.redemptionPeriods = [
      {
        value: '60_DAYS',
        text: '60 dias após o recebimento da solicitação pela Veins',
      },
      { value: 'DONT_APPLY', text: 'Não se aplica a essa rodada' },
    ];

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/investment/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      try {
        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/investment/${this.viewData.id}`
            : '/investment/',
          method: this.viewData.id ? 'put' : 'post',
          data: this.state,
        });

        this.$toast.success('Investimento incluída com sucesso');

        this.$router.push('/investments');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
